import React from 'react';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import MomentUtils from '@date-io/moment';
import { ThemeProvider } from '@material-ui/styles';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import  renderRoutes  from './utils/renderRoutes.js'; 
import theme from './theme'; 
import { useSelector } from 'react-redux';
import routes from './routes';
import {
  ScrollReset, 
} from './components';
import './mixins/chartjs';
import './mixins/moment';
import './mixins/validate';
import './mixins/prismjs';
import './mock';
import './assets/scss/index.scss';
const history = createBrowserHistory();

const App = (props) => {  
  const user = useSelector(state=>state.session.user);  
  return ( 
      <ThemeProvider theme={theme}>
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <Router history={history} props>
           <ScrollReset /> 
            {renderRoutes(routes,user)}
          </Router>
        </MuiPickersUtilsProvider>
      </ThemeProvider> 
  );
};
 
export default  App;
